import { linkTo, idtype } from "querypieces";

export default `
...on pageBuilder_recentBlog_BlockType {
  ${idtype}
  heading
  label
  ${linkTo}
}
`;
